import { injectOrBuildContainer } from '@monofe/di';
export const TYPES = {
  ITourDataResolver: Symbol.for('ITourDataResolver')
};
export function injectTourDataResolver() {
  let container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : injectOrBuildContainer();
  return container.get(TYPES.ITourDataResolver);
}
export function bindTourDataResolver(val) {
  let container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : injectOrBuildContainer();
  container.bind(TYPES.ITourDataResolver, val);
}
export function unbindTourDataResolver() {
  let container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : injectOrBuildContainer();
  container.remove(TYPES.ITourDataResolver);
}